<template>
    <CodiceFeanorView tool-module="vigenere" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
